function validateCardExpiryPeriod(period: string) {
  const value = period;
  let message = '';
  let success = false;

  if (!value) {
    message = '카드 유효기간 입력은 필수입니다.';
  } else {
    message = '';
    success = true;
  }

  return { success, message };
}

export default validateCardExpiryPeriod;
